import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PlannerBoardColumnComponent } from './planner-board-column.component';


export class PlannerBoardColumnModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule
  ],
  declarations: [ PlannerBoardColumnComponent ],
  exports: [ PlannerBoardColumnComponent ]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
